import React from 'react'
import { CheckmarkBackgroundIcon, TransferIcon } from '@paypalcorp/pp-react'

export const faceScanConfig = {
  active: {
    header: {
      image: (
        <div className="tid-header__image-container">
          <img
            src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/id-photo-horizontal.svg"
            alt="id-photo-horizontal"
          />
          <TransferIcon size="xl2" className="tid-header__image-active-icon" />
          <img
            src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/person-photo.svg"
            alt="person-photo"
          />
        </div>
      ),
      title: 'tetherId.facescan.active.header.title',
      status: 'tetherId.facescan.active.header.status',
    },
    contents: [
      {
        title: 'tetherId.facescan.active.content1.title',
        isList: false,
        desc: 'tetherId.facescan.active.content1.desc1',
      },
      {
        title: 'tetherId.facescan.active.content2.title',
        isList: true,
        desc: [
          'tetherId.facescan.active.content2.desc1',
          'tetherId.facescan.active.content2.desc2',
          'tetherId.facescan.active.content2.desc3',
        ],
      },
      {
        title: 'tetherId.facescan.active.content3.title',
        isList: false,
        desc: 'tetherId.facescan.active.content3.desc1',
      },
    ],
    button: {
      text: 'tetherId.facescan.active.button.text',
      name: 'deleteFaceScanData',
      id: 'deleteFaceScanDataBtn',
    },
    error: {
      message: 'tetherId.facescan.error.message.text',
    },
    modal: {
      req: {
        title: 'tetherId.facescan.delete.req.title',
        desc: 'tetherId.facescan.delete.req.desc',
        button: {
          text: 'tetherId.facescan.delete.req.button',
          name: 'requestToDeleteData',
          id: 'requestToDeleteDataBtn',
        },
      },
      confirm: {
        icon: (
          <CheckmarkBackgroundIcon
            size="xl2"
            className="tid-modal-content__icon-image"
          />
        ),
        title: 'tetherId.facescan.delete.confirm.title',
        button: {
          text: 'tetherId.facescan.delete.confirm.button',
          name: 'doneDeletionConfirm',
          id: 'doneDeletionConfirmBtn',
        },
      },
    },
  },
  inactive: {
    header: {
      image: (
        <img
          src="https://www.paypalobjects.com/paypal-ui/illustrations/focused/svg/person-no-photo.svg"
          alt="person-no-photo"
        />
      ),
      title: 'tetherId.facescan.inactive.header.title',
      status: 'tetherId.facescan.inactive.header.status',
    },
    contents: [
      {
        title: 'tetherId.facescan.inactive.content1.title',
        desc: 'tetherId.facescan.inactive.content1.desc1',
      },
      {
        desc: 'tetherId.facescan.inactive.content2.desc1',
      },
    ],
    error: {
      message: 'tetherId.facescan.error.message.text',
    },
  },
}
